/***********************************
 * NOTE: This script uses an outdated setup for actions/reducers.
 * We are now using @reduxjs/toolkit to simplify this. This script will eventually be migrated.
 * If you are setting up a new Redux view model, follow the example of the WorksheetEditor scripts instead.
 ***********************************/

export const SETTINGS_GET = 'SETTINGS_GET';
export const SETTINGS_GET_RESOLVE = 'SETTINGS_GET_RESOLVED';
export const SETTINGS_GET_REJECT = 'SETTINGS_GET_REJECTED';
export const getSettings = () => ({ type: SETTINGS_GET });
export const getSettingsResolve = () => ({ type: SETTINGS_GET_RESOLVE });
export const getSettingsReject = () => ({ type: SETTINGS_GET_REJECT });
